import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { g_params } from 'src/app/classes/global-param';
import { CUtilit } from 'src/app/classes/utilit';
import { UserParam } from 'src/app/classes/json-interface';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';


interface Stock {
  ProductCode: string;
  ProductName: string;
  ProductFamilyCode: string;
  ProductFamilyName: string;
  ProductUnit1: string;
  Stock: number;
  MinStock: number;
  OrderedQty: number;
  NeededQty: number;
  ForecastQty: number;
}

interface StockFactory {
  Code: number;
  Label: string;
}

interface StockFamily {
  Code: string;
  Label: string;
}

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css']
})
export class StockComponent implements OnInit {

  @ViewChild('tableStock', { static: true }) matTableStock!: MatTable<Stock>;        // Afficher dans la table html
  @ViewChild('TablePaginator', { static: true }) tablePaginatorStock!: MatPaginator;
  @ViewChild(MatSort, {static: false}) mTableSort!: MatSort;

  mSelectedFactory?: StockFactory = undefined;
  mSelectedFamily?: StockFamily = undefined;
  mfactories: StockFactory[] = [];
  mProductFamilies: StockFamily[] = [];
  mSearchText: String = ''; // Texte de recherche
  HTML_Param: UserParam = CUtilit.loadOrInitUserParam();
  inProgress: boolean = false;   // Si on load/refresh les données

  HTML_STOCK_COL = {
    ProductCode: 'ProductCode',
    Label: 'ProductName',
    Family: 'ProductFamilyName',
    Unit: 'ProductUnit1',
    Stock: 'Stock',
    MinStock: 'MinStock',
    OrderedQty: 'OrderedQty',
    NeededQty: 'NeededQty',
    ForecastQty: 'ForecastQty'
  };

  dataSource: MatTableDataSource<Stock>; // Données de stock

  constructor(private mArmaServMethod: ArmaServServerMethods,
              private mSanitizer: DomSanitizer,
              private mRoute: ActivatedRoute,
              private mToolbar: AppToolbarService,
              private mTranslate: TranslateService) {
    this.dataSource = new MatTableDataSource<Stock>([]);
  }

  ngOnInit(): void {
    this.mToolbar.toolbarPageTitle = 'Stock';
    this.dataSource.paginator = this.tablePaginatorStock;
    this.initData().catch(console.error);
  }

  get displayedColumns(): string[] {
    const result: string[] = [];
    result.push(this.HTML_STOCK_COL.ProductCode);
    result.push(this.HTML_STOCK_COL.Label);
    result.push(this.HTML_STOCK_COL.Family);
    result.push(this.HTML_STOCK_COL.Unit);
    result.push(this.HTML_STOCK_COL.Stock);
    result.push(this.HTML_STOCK_COL.MinStock);
    result.push(this.HTML_STOCK_COL.OrderedQty);
    result.push(this.HTML_STOCK_COL.NeededQty);
    result.push(this.HTML_STOCK_COL.ForecastQty);
    return result;
  }

  updateFactory() {
    this.refreshData().catch(console.error);
  }

  updateFamily() {
    this.refreshData().catch(console.error);
  }

  applyFilter() {
    this.dataSource.filter = this.mSearchText.trim().toLowerCase();
    this.matTableStock.renderRows(); // Affichage des données dans le tableau
    this.dataSource._updateChangeSubscription();
  }

  async initData() {
    this.mfactories = await this.mArmaServMethod.getListFactory();
    this.mProductFamilies = await this.mArmaServMethod.getListProductFamily();
    this.mfactories.splice(0, 0, {Code: -1, Label: await this.mTranslate.get('Toutes').toPromise()});
    this.mProductFamilies.splice(0, 0, {Code: '', Label: await this.mTranslate.get('Toutes').toPromise()});
    // Par défaut on cherche à sélectionner l'usine qu'on a dans g_params.g_factoryName
    const indexFactory: number = this.mfactories.map(function(e) { return e.Label.toUpperCase(); }).indexOf(g_params.g_factoryName.toUpperCase());
    if (indexFactory == -1) {
      this.mSelectedFactory = this.mfactories[0];
    } else {
      this.mSelectedFactory = this.mfactories[indexFactory];
    }
    this.mSelectedFamily = this.mProductFamilies[0];
    this.refreshData().catch(console.error);
  }

  async refreshData() {
    if (!this.inProgress) {
      this.inProgress = true;
      try {
        const factoryCode: number = (this.mSelectedFactory != null) ? this.mSelectedFactory.Code : 1;
        const familyCode: string = (this.mSelectedFamily != null) ? this.mSelectedFamily.Code : '';
        this.dataSource.data = await this.mArmaServMethod.getStockData(factoryCode, familyCode, this.HTML_Param.SteelStock);
        //Tri par code produit
        this.dataSource.data.sort((a, b) => a.ProductCode.localeCompare(b.ProductCode));
        this.dataSource.sort = this.mTableSort;
      } finally {
        this.inProgress = false;
      }
    }
  }

  IsStockIncorrect(stock: Stock): boolean {
    return stock.MinStock > stock.Stock;
  }

  CheckSteelStock() {
    if (this.HTML_Param) CUtilit.saveUserParam(this.HTML_Param);
    this.refreshData().catch(console.error);
  }

}
